import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import { useLoginModal } from "../../Context/LoginModalContext";
import { toast } from "react-toastify";

const balanceDiv = {
  backgroundColor: "#003D38",
  width: "80%",
  margin: "auto",
};

const AddToWalletModal = ({ isAuth, open, onClose, points = 0 }) => {
  const inputRef = useRef(null);
  const { openLoginModal } = useLoginModal();
  const [inputWallet, setInputWallet] = useState(50);

  useEffect(() => {
    if (open) {
      // Slight delay to ensure DOM is ready
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [open]);

  if (!open) return null;

  const handelPay = (e) => {
    e.preventDefault();
    console.log("jiii");
    console.log({ inputWallet });
    if (isAuth) {
        toast.error("Payment options are currently unavailable. Please visit the site again later.");
    } else {
        openLoginModal();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          background: "linear-gradient(135deg, #00524C, #048E84)",
          borderRadius: "20px",
          color: "#fff",
          padding: "0",
          width: "650px",
        },
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center p-6  mt-2">
        <div className=" w-full">
          <DialogTitle
            style={{ fontWeight: "bold", fontFamily: "Inter", fontSize: "25px" }}
            className=" add-wallte-title text-white text-center font-semibold p-0 "
          >
            Add to Wallet
          </DialogTitle>
        </div>
        <button onClick={onClose} className="text-white px-2 border-0 rounded-lg" style={{ background: "#00605d" }}>
          X
        </button>
      </div>

      {/* Points Info */}
      <div style={balanceDiv} className=" mx-6 rounded-lg p-2 text-center my-4">
        <p className="text-white text-sm mt-1">
          Your Available Points is :<span className="mx-1 text-yellow-400">🪙</span>
          <span className="font-bold text-white text-lg">{points}</span>
        </p>
        <p style={{ fontSize: "12px" }} className=" text-gray-300">
          1 Point is equal to 1 USD
        </p>
      </div>

      {/* Stepper & Content */}
      <DialogContent style={{ width: "80%", backgroundColor: "#003D38", margin: "auto" }} className="flex gap-4 rounded-lg py-5">
        {/* Stepper */}
        <div className="w-1/3  text-white pt-1">
          <div className="flex flex-col gap-0 relative">
            {/* Step 1 */}
            <div className="flex items-start gap-3 mt-2">
              <div className="flex flex-col items-center">
                <div style={{ border: "3px solid white" }} className="h-20 rounded-full"></div>
                <div className="h-40 mt-2 mb-2 border border-solid border-grey-100"></div>
              </div>
              <div className="">
                <p style={{ color: "whitesmoke", fontWeight: "400", fontSize: "12px" }} className=" p-0 m-0">
                  Step 1
                </p>
                <span className="text-xs text-gray-300">Enter the value</span>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start gap-3 ">
              <div className="flex flex-col items-center">
                <div className="h-20  rounded-full bg-white"></div>
                <div className="h-40 mt-2 mb-2 border border-solid border-grey-100"></div>
              </div>
              <div>
                <p style={{ color: "whitesmoke", fontWeight: "400", fontSize: "12px" }} className=" p-0 m-0">
                  Step 2
                </p>
                <span className="text-xs text-gray-300">Pay by card</span>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start gap-3">
              <div className="flex flex-col items-center">
                <div className="h-20  rounded-full bg-white"></div>
              </div>
              <div>
                <p style={{ color: "whitesmoke", fontWeight: "400", fontSize: "12px" }} className=" p-0 m-0">
                  Step 3
                </p>
                <span className="text-xs text-gray-300">Review Details</span>
              </div>
            </div>
          </div>
        </div>

        {/* Input & Action */}
        <div style={{ backgroundColor: "#00272496" }} className=" w-2/3 rounded-xl p-4 text-white flex flex-col justify-between">
          <form onSubmit={handelPay}>
            <div>
              <div className="flex justify-between items-center mb-2">
                <p className="text-sm">Enter points</p>
                <p className="text-sm text-gray-300">Step 1</p>
              </div>
              <div className="w-1/2 m-auto">
                <p style={{ fontSize: "12px" }} className="m-0 p-2 text-center text-white">
                  Points
                </p>
                <input
                  ref={inputRef}
                  type="number"
                  onChange={(e) => setInputWallet(e.target.value)}
                  style={{ fontSize: "20px", fontWeight: "500", background: "transparent", WebkitAppearance: "none", MozAppearance: "textfield" }}
                  defaultValue={50.0}
                  min={30}
                  value={inputWallet}
                  placeholder="Type something..."
                  className="w-full p-1  text-white border text-center border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-teal-400"
                />
                {/* <input
                type="number"
                style={{ fontSize: "25px" }}
                className="w-full p-1  rounded-md text-center text-black font-semibold"
                defaultValue={30.0}
                step="0.01"
              /> */}
              </div>
              <p className=" w-2/3 m-auto m-0 p-1 text-center" style={{ fontSize: "10px" }}>
                Minimum amount of deposite is 50 USD{" "}
              </p>
            </div>
            <button type="submit" className="bg-teal-300 wallet-pay-btn text-black font-semibold w-full mt-6 py-2 rounded-md">
              Pay by Debit/Credit
            </button>
          </form>
        </div>
      </DialogContent>

      {/* Footer Note */}
      <DialogActions className="bg-yellow-300 rounded-b-xl px-6 py-3 justify-center ">
        <div style={{ background: "#FEDE76" }} className="w-4/5 mx-auto rounded-xl shadow-md p-1 flex ">
          <p style={{ fontSize: "10px" }} className="text-black font-semibold m-0 p-1">
            Note*:-
          </p>
          <p style={{ fontSize: "10px" }} className="text-black leading-relaxed m-0 p-1">
            Use your coins for instant mobile recharges, eSIMs, and gift cards from top brands like Amazon, Uber, and more — fast, secure, and global.
          </p>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AddToWalletModal;
